var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoEmbedIcon = function SvgVideoEmbedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.33334C30 5.78106 29.5523 5.33334 29 5.33334H4.33337C3.78109 5.33334 3.33337 5.78106 3.33337 6.33334V25.6667C3.33337 26.219 3.78109 26.6667 4.33337 26.6667H29C29.5523 26.6667 30 26.219 30 25.6667V6.33334Z",
    stroke: "var(--on-surface)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.134C23.1667 15.5189 23.1667 16.4811 22.5 16.866L13.5 22.0622C12.8334 22.4471 12 21.966 12 21.1962V10.8039C12 10.0341 12.8334 9.55293 13.5 9.93783L22.5 15.134Z",
    stroke: "var(--on-surface)",
    strokeWidth: 2
  })));
};
export default SvgVideoEmbedIcon;